import styled from 'styled-components'
import {media} from '../../theme/config'

export const TopBar = styled.div`
  padding: 0 20px;
  height: 20px;
  background: ${props => `linear-gradient(to right, ${props.theme.colors.greyscale.subtle}, ${props.theme.colors.greyscale.white}`});
  font-size: ${props => props.theme.typography.fontSize.fs2};
  line-height: ${props => props.theme.typography.lineHeight.lh2};
  color: ${props => props.theme.colors.greyscale.black}
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${media.mobileL} {
    padding: 0 15px;
    justify-content: flex-start;
    height: 36px;
  }
`;

// TODO: This is originally a link but styles do not match with those of the links
// Need to clarify if we should treat it differently
export const Text = styled.div`
  font-style: italic;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  a {
    text-decoration: unset;
    color: ${({theme}) => theme.colors.greyscale.dark}

    &:hover, &:focus {
      color: ${({theme}) => theme.colors.greyscale.darker}
    }
  }
  
  @media ${media.mobileL} {
    margin-right: auto;
    margin-left: 15px;
  }
`
